import { useEffect, useState } from "react";
import Hearder from "../../commun/Hearder"
import SideBar from "../../commun/SideBar"

export const BulkUpdateRate = () => {

    const [rooms, setRooms] = useState([
        {
            id: 1,
            prices: ["2500", "2500", "4000", "4450", "4450", "0", "0", "2400", "2500", "1500", "2200"],
        },

    ]);

    const handlePriceChange = (roomId, idx, newValue) => {
        // Optional: basic sanitization - allow empty or numeric strings
        const sanitized = newValue === "" ? "" : newValue; // keep as string; convert to number if needed

        setRooms((prev) =>
            prev.map((r) => {
                if (r.id !== roomId) return r;
                // clone prices array and update index
                const pricesCopy = [...r.prices];
                // ensure index exists (if not, expand)
                if (idx >= pricesCopy.length) {
                    for (let i = pricesCopy.length; i <= idx; i++) pricesCopy[i] = "";
                }
                pricesCopy[idx] = sanitized;
                return {
                    ...r,
                    prices: pricesCopy,
                };
            })
        );
    };

    // Number of days to show at once (9 as requested)
    const DEFAULT_DAYS = 11;

    // State for dates and the current "start" date
    const [dates, setDates] = useState([]);
    const [startDate, setStartDate] = useState(null);

    // Helpers
    const formatShortWeekday = (d) =>
        d.toLocaleString("en-US", { weekday: "short" }).toUpperCase();
    const formatShortMonth = (d) =>
        d.toLocaleString("en-US", { month: "short" }).toUpperCase();
    const formatLegendDate = (d) =>
        `${d.getDate()} ${d.toLocaleString("en-US", { month: "short" })} ${d.getFullYear()}`;

    // Generate N days starting from `start` (inclusive)
    const generateDates = (start, n = DEFAULT_DAYS) => {
        const arr = [];
        for (let i = 0; i < n; i++) {
            const dd = new Date(start);
            dd.setDate(start.getDate() + i);
            arr.push({
                dateObj: dd,
                short: formatShortWeekday(dd),
                day: dd.getDate(),
                mon: formatShortMonth(dd),
            });
        }
        setDates(arr);
        setStartDate(new Date(start)); // keep a copied Date object
    };

    // Initial dates on component mount (start from current date)
    useEffect(() => {
        const initial = new Date(); // today
        initial.setHours(0, 0, 0, 0);
        generateDates(initial, DEFAULT_DAYS);
    }, []);



    // Next N days
    const handleNext = () => {
        if (!startDate) return;
        const nextStart = new Date(startDate);
        nextStart.setDate(startDate.getDate() + DEFAULT_DAYS);
        generateDates(nextStart, DEFAULT_DAYS);
    };

    // Prev: directly show previous DEFAULT_DAYS (no prompt)
    const handlePrev = () => {
        if (!startDate) return;
        const prevStart = new Date(startDate);
        prevStart.setDate(startDate.getDate() - DEFAULT_DAYS);
        generateDates(prevStart, DEFAULT_DAYS);
    };

    return (
        <>
            <style>{`
             .card-body {
                 padding: 15px;
                 }
           `}</style>
            <style jsx="true">{`
        .calendar-header { border-bottom: 1px solid #e9ecef; padding: 0px !important; border-radius: 6px 6px 0px 0px;}
        .date-cell { width: 88px; min-width: 88px; padding: 6px 10px; border-radius: 0px; background: #f8f9fa; border-right: 1px dotted #726e6e45;}
        .rooms-row { border: 1px solid #eef0f2;  padding-bottom: 0px ;}
        .room-info {  justify-items: center;}
        .dates-row { padding-left: 3px; }
        .date-box {  width: 88px; min-width: 88px; padding: 6px 10px; border-radius: 0px;}
        .price-input { text-align: center; }
        .price-input.is-zero { background: #ffecec; border-color: #ffb3b3; }
        .avail { font-weight: 600; color: #6c757d; }
        .date-box .badge.bg-danger { font-size: 0.7rem; padding: 0.25rem 0.4rem; }
        .legend-square { display:inline-block; width:14px; height:10px; border-radius:3px; margin-right:6px; vertical-align:middle;}
        .stop-sell { background:#f4c2c2; border:1px solid #e8a6a6; }
        .min-stay { background:#ffe6a7; border:1px solid #f1d092; }
        .close-dep { background:#dbe9ff; border:1px solid #b6d2ff; }
        .close-arr { background:#e8f7e8; border:1px solid #cfeccf; }
        .no-avail { background:#ffd6d6; border:1px solid #ffbcbc; }
        /* make inner rows horizontally scrollable nicely */
        .calendar-header .d-flex, .dates-row .d-flex { gap: 12px; }
        /* small screens */
        @media (max-width: 768px) {
          .room-info { min-width: 200px; }
          .date-box { min-width: 90px; }
          .date-cell { min-width: 72px; }
        }
        
    .calendar-header .d-flex, .dates-row .d-flex {
     gap: 0px !important; 
}


/* base tweaks (keep your existing rules above) */
.rooms-section .rooms-row { border: none; } /* remove double outer border */

/* make each date-box visually separated */
.date-box {
  width: 88px;
  min-width: 88px;
  padding: 6px 10px;
  border-radius: 0;

  border-left: 1px solid #e9ecef;
  background: #ffffff;
}

  .date-box {
  border-top: 1px solid #d6d6d6; 
}

/* style the 'Current' label cell */
.rooms-section.current .room-info .fw-bold {
  background: #f8f9fa;
  border-right: 1px solid #e9ecef;
  padding: 20px;
  height: 100%;
}

/* -- NEW row: bottom accent line below the new row cells -- */
.rooms-section.new  .date-box {
  /* add a thin bottom border to show 'new' separation */
  border-bottom: 1px solid #d6d6d6;
  padding-bottom: 8px;
}

/* style the 'New' label cell */
.rooms-section.new .room-info .fw-bold {
  background: #f8f9fa;
  border-right: 1px solid #e9ecef;
  padding: 18px;
  height: 100%;
}

/* inputs inside date-box */
.price-input {
  border: 1px solid #dfe3e6;
}

/* keep header and date cells aligned */
.calendar-header .date-cell,
.date-box {
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}






            `}</style>
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />
                    <div className="container">
                        <div className="page-inner">

                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <label>Rules*</label>
                                    <select className="form-select">
                                        <option>Rates</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label>Rooms*</label>
                                    <select className="form-select">
                                        <option>Select</option>
                                    </select>
                                </div>
                            </div>

                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="mb-3">
                                                <label>Form*</label>
                                                <input type="date" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div>
                                                <label>To*</label>
                                                <input type="date" className="form-control" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="calendar-header overflow-auto">
                                        <div className="d-flex align-items-center" style={{ position: "relative" }}>
                                            <div style={{ width: "110px" }}></div>

                                            {/* LEFT / PREV BUTTON */}
                                            <div className="position-relative">
                                                <button
                                                    onClick={handlePrev}
                                                    aria-label="Show previous dates"
                                                    className="btn btn-sm d-flex justify-content-center align-items-center"
                                                    style={{
                                                        backgroundColor: "white",

                                                        width: "28px",
                                                        height: "78px",
                                                        border: "1px solid #ddd",
                                                        position: "absolute",
                                                        top: "-39px",
                                                        right: "2px"
                                                    }}
                                                >
                                                    <i className="fas fa-chevron-left" style={{ fontSize: "15px" }}></i>
                                                </button>
                                            </div>

                                            {/* Dates */}
                                            {dates.map((d, i) => (
                                                <div key={i} className="date-cell text-center">
                                                    <div className="fw-bold small">{d.short}</div>
                                                    <div className="h5 mb-0">{d.day}</div>
                                                    <div className="small text-muted">{d.mon}</div>
                                                </div>
                                            ))}

                                            {/* RIGHT / NEXT BUTTON */}
                                            <div className="position-relative">
                                                <button
                                                    onClick={handleNext}
                                                    aria-label="Show next dates"
                                                    className="btn btn-sm d-flex justify-content-center align-items-center"
                                                    style={{
                                                        backgroundColor: "white",

                                                        width: "28px",
                                                        height: "78px",
                                                        border: "1px solid #ddd",
                                                        position: "absolute",
                                                        top: "-39px",
                                                        right: "-29px"
                                                    }}
                                                >
                                                    <i className="fas fa-chevron-right" style={{ fontSize: "15px" }}></i>
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="rooms-section current">
                                        {rooms.map((room) => (
                                            <div key={room.id} className="rooms-row" >
                                                <div >
                                                    <div className="d-flex align-items-start">
                                                        <div className="room-info me-3" style={{ paddingRight: "9px" }}>
                                                            <div className="d-flex align-items-center ">
                                                                <div>
                                                                    <div className="fw-bold" style={{ borderBottom: "1px solid #e9ecef" }}>current</div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        {/* Date cells for this room */}
                                                        <div className="dates-row overflow-auto flex-grow-1">

                                                            <div className="d-flex">
                                                                {room.prices.map((idx) => {
                                                                    return (
                                                                        <div key={idx} className="date-box text-center">
                                                                            2500
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="rooms-section new">
                                        {rooms.map((room) => (
                                            <div key={room.id} className="rooms-row">
                                                <div >
                                                    <div className="d-flex align-items-start">
                                                        <div className="room-info" >
                                                            <div className="d-flex align-items-center">
                                                                <div>
                                                                    <div className="fw-bold" style={{ width: "89px" }}>New</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <button className="btn btn-sm py-2 px-1" style={{ marginTop: "13px" }} data-bs-toggle="tooltip" data-bs-placement="top" title="Copy Acress"><i class="fa fa-angle-double-right" style={{ fontSize: "16px" }}></i></button>

                                                        {/* Date cells for this room */}
                                                        <div className="dates-row overflow-auto flex-grow-1">

                                                            <div className="d-flex">
                                                                {room.prices.map((price, idx) => {
                                                                    return (
                                                                        <div key={idx} className="date-box text-center">
                                                                            {/* PRICE INPUT - NOW EDITABLE */}
                                                                            <input
                                                                                className="form-control form-control-sm price-input"
                                                                                value={price}
                                                                                onChange={(e) => handlePriceChange(room.id, idx, e.target.value)}
                                                                            />
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="d-flex">
                                        <div className="d-flex gap-3 mt-3" >
                                            <div style={{ marginBottom: "34px" }}>
                                                <select className="form-select form-control" style={{ width: "135px" }}>
                                                    <option>Discount</option>
                                                </select>
                                            </div>
                                            <div style={{ marginBottom: "34px" }}>
                                                <select className="form-select form-control" style={{ width: "135px" }}>
                                                    <option>Percentage</option>
                                                </select>
                                            </div>
                                            <div style={{ marginBottom: "34px" }}>
                                                <input type="text" className="form-control" />
                                            </div>

                                            {/* <div className="row">
                                            <div className="col-md-1">
                                                <label>Mon</label>
                                                <input type="checkbox"/>
                                            </div>
                                             <div className="col-md-1">
                                                <label>Tue</label>
                                                <input type="checkbox"/>
                                            </div>
                                             <div className="col-md-1">
                                                <label>Wed</label>
                                                <input type="checkbox"/>
                                            </div>
                                             <div className="col-md-1">
                                                <label>Thu</label>
                                                <input type="checkbox"/>
                                            </div>
                                             <div className="col-md-1">
                                                <label>Fri</label>
                                                <input type="checkbox"/>
                                            </div>
                                             <div className="col-md-1">
                                                <label>Sat</label>
                                                <input type="checkbox"/>
                                            </div>
                                             <div className="col-md-1">
                                                <label>Sun</label>
                                                <input type="checkbox"/>
                                            </div>
                                        </div> */}
                                        </div>

                                        <div className="d-flex mt-3" style={{ gap: "60px" }}>
                                            <div>
                                                <div style={{ marginBottom: "34px" }}>Mon</div>
                                                <input type="checkbox" />
                                            </div>
                                            <div>
                                                <div style={{ marginBottom: "34px" }}>Tue</div>
                                                <input type="checkbox" />
                                            </div>
                                            <div>
                                                <div style={{ marginBottom: "34px" }}>Wed</div>
                                                <input type="checkbox" />
                                            </div>
                                            <div>
                                                <div style={{ marginBottom: "34px" }}>Thu</div>
                                                <input type="checkbox" />
                                            </div>
                                            <div>
                                                <div style={{ marginBottom: "34px" }}>Fri</div>
                                                <input type="checkbox" />
                                            </div>
                                            <div>
                                                <div style={{ marginBottom: "34px" }}>Sat</div>
                                                <input type="checkbox" />
                                            </div>
                                            <div>
                                                <div style={{ marginBottom: "34px" }}>Sun</div>
                                                <input type="checkbox" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-end">
                                        <button className="btn btn-primary">Apply</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
